import React, { useState, useEffect } from 'react'
import { defaultSettings, ISettings } from '../modules/profile/components/settings/SettingsModel'
import { defaultAccount, IAccount } from './MyAccountModel'
import Popup from './Popup';
import './style.css';
import region from './address/region.json'
import city from './address/city.json'
import companyLogo from './Avision_Logo.png';
import { db, storage } from './firebase';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import { collection, addDoc } from "firebase/firestore";
import axios from 'axios';
import liff from '@line/liff';

import membercard from './membercard.png';
import { ReactSession } from 'react-client-session';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { getStorage, ref as ref_storage, getDownloadURL, listAll } from "firebase/storage";
import { useRef } from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
// import ReactDOM from 'react-dom';
import $ from 'jquery';
import JsBarcode from 'jsbarcode';
import QRCode from "react-qr-code";
import Col from 'react-bootstrap/Col';
import { initialStore } from '../stores/init_config_store';
import { NewsSetup } from '../models/news';
import { formatNumber, getImageUrl, updateState } from '../utils/function-utils';
import Dialog from '../components/dialog/Dialog';

type EventAlert = {
  showEvent: boolean;
}

export function Homepage() {

  //AVCDAAV.002  24/03/2025  Add code for Adding state dialog events
  const [event, setEvent] = useState<EventAlert>({
    showEvent: false,
  });
  //C-AVCDAAV.002  24/03/2025  Add code for Adding state dialog events


  useEffect(() => {
    //  fetchLiff();
    //  fetchchecklogin();
    //checkcustomerlogin();
    const getAllData = async () => {
      //  await setfileconfig()
      setfileconfig()
      //  await fetchLiff()
      //    await updatadata()
      //AVCDAAV.002  25/03/2025  Add code for  Add loading news
      await setNewsConfig();
      //C-AVCDAAV.002  25/03/2025  Add code for  Add loading news
    };

    getAllData();
    JsBarcode("#barcode", customer_Data.mobile_phone_no, {
      displayValue: false,
    });
    //AVCDAAV.002  24/03/2025  Add code for Adding update state dialog event
    const eventIsShown = window.sessionStorage.getItem("showEvent");
    if (!eventIsShown) {
        updateState<EventAlert>({ showEvent: true},setEvent);
    }
    const handleUnload = () => {
      window.sessionStorage.removeItem("showEvent");
    }
    window.addEventListener("unload", handleUnload);
    return () => window.removeEventListener("unload", handleUnload);
  //C-AVCDAAV.002  24/03/2025  Add code for Adding update state dialog event
    /*  const getAllData = async () => {
        await fetchweb()
      //  await fetchLiff()
      //  await updatadata()
      };
        getAllData();*/
  }, [])
  // const storage = getStorage('gs://avliffmemberdev.appspot.com');
  const [logoImageweb, setLogoImageweb] = useState('');
  const [logoImage, setLogoImage] = useState('');
  const [cardImage, setCardImage] = useState('');
  const [cardDetailImage, setCardDetailImage] = useState('');
  const session_customer_Data = sessionStorage.getItem('Customerdata');
  const customer_Data = JSON.parse("" + session_customer_Data);
  const [data1, setdata1] = useState('');
  const [isOpenpopup, setIsOpenpopup] = useState(false);
  //AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
  const logo = initialStore((state) => state.logo);
  //C-AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image

    //AVCDAAV.002  25/03/2025  Add code for  Add loading news

  const [news, setNews] = React.useState<NewsSetup[]>([]);

  async function setNewsConfig(): Promise<void> {
    const newsConfigFile = window.sessionStorage.getItem("setupNews");
    const newsConfigIsNotExist = !newsConfigFile;
    if (newsConfigIsNotExist) return;
    try {
      const newsConfig: NewsSetup[] = JSON.parse(newsConfigFile);
      for (let i = 0; i < newsConfig.length; i++) {
        const news = newsConfig[i];
        const url = await getImageUrl(news.news_url);
        if (!url) continue;
        news.news_url = url;
      }
      setNews(newsConfig);
    } catch (error) {
      console.log(error)
    }
  }
  //C-AVCDAAV.002  25/03/2025  Add code for  Add loading news

  //AVCDAPNF.005  25/02/2025  Add Code for format date
  const dateFormat = React.useMemo(() => {
    const date = new Date(customer_Data.nearlyExpireDate)
    return customer_Data.nearlyExpireDate === '0001-01-01'
      ? ''
      : new Intl.DateTimeFormat(['ban', 'id']).format(date)
  }, [customer_Data.nearlyExpireDate])
  //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม format date

  async function setfileconfig() {
          const schemewebdefault = JSON.parse(""+window.sessionStorage.getItem("schemewebdefault"));
          const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
            const club_scheme = JSON.parse(""+window.sessionStorage.getItem("club_scheme"));
            const customerdata = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));



          const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
          getDownloadURL(storageRef_logoweb).then((url) => {
            setLogoImageweb(url)
          });
          club_scheme.forEach((val:any, key:any) => {
             if (val.scheme==customerdata.scheme) {
               const storageRef_card = ref_storage(storage, val.card_image_front_path_link);
               const storageRef_card_detail = ref_storage(storage, val.card_image_back_path_link);
               getDownloadURL(storageRef_card).then((url) => {
                 // console.log(url);
                 setCardImage(url)
               });
               getDownloadURL(storageRef_card_detail).then((url) => {
                 // console.log(url);
                 setCardDetailImage(url)
               });
             }

          })

          const storageRef_logo = ref_storage(storage, setupwebdefault.club_logo_path);



          // console.log(customer_Data.mobile_phone_no);
          getDownloadURL(storageRef_logo).then((url) => {
            // console.log(url);
            setLogoImage(url)
          });


          const storageRef1 = ref_storage(storage, 'config_file/club_scheme_web.json');
          getDownloadURL(storageRef1).then((url1) => {
            //  console.log(ur
             axios.get(url1)
            .then(res=> console.log())

            .catch(err=> console.log())
          });
          const cus_data = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
          const setupwebdefaultweb = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
          console.log(setupwebdefaultweb.consent1_path);

          if (setupwebdefaultweb.consent1_path && setupwebdefaultweb.consent1_require==true) {
            if (cus_data.consent1==true) {
              console.log("consent1_require.",setupwebdefaultweb.consent1_require);
            }else{
              // popup open
              if (isOpenpopup==false) {
                setIsOpenpopup(true)
                openpopup()
              }

            }
          }
          if (setupwebdefaultweb.consent2_code && setupwebdefaultweb.consent2_require==true) {
            if (cus_data.consent2==true) {
              console.log("consent2_require.",setupwebdefaultweb.consent1_require);
            }else{
              // popup open
              if (isOpenpopup==false) {
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent3_code && setupwebdefaultweb.consent3_require==true) {
            console.log("cus_data.consent3",cus_data.consent3);
            if (cus_data.consent3==true) {
              console.log("consent2_require.",setupwebdefaultweb.consent3_require);
            }else{
              // popup open
              if (isOpenpopup==false) {
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent4_code && setupwebdefaultweb.consent4_require==true) {
            if (cus_data.consent4==true) {
              console.log("consent2_require.",setupwebdefaultweb.consent4_require);
            }else{
              // popup open
              if (isOpenpopup==false) {
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent5_code && setupwebdefaultweb.consent5_require==true) {
            if (cus_data.consent5==true) {
              console.log("consent2_require.",setupwebdefaultweb.consent5_require);
            }else{
              // popup open
              if (isOpenpopup==false) {
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }
          if (setupwebdefaultweb.consent6_code && setupwebdefaultweb.consent6_require==true) {
            if (cus_data.consent6==true) {
              console.log("consent2_require.",setupwebdefaultweb.consent6_require);
            }else{
              // popup open
              if (isOpenpopup==false) {
                setIsOpenpopup(true)
                openpopup()
              }
            }
          }

        //   window.sessionStorage.removeItem("Confirmdata");
          window.sessionStorage.removeItem("OTPSMS");


  }
   async function openpopup() {
      console.log("popuppppp");

   }

  const [ note, setNote ] = useState("")
  const [data, setData] = useState<IAccount>(defaultAccount)
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const togglePopup = () => {
    setIsOpen(!isOpen);
  }

  const handleClick = async () => {
    console.log(data)
  }
  const [activeCard, setactiveCard] = useState(false);
  const [activeBarcode, setactiveBarcode] = useState(false);
  const [activeQr, setactiveQr] = useState(false);

    const checkBtnClick =( e : any) => {
        // const theValue = event.currentTarget.value;
        // console.log("the value:", theValue);
        // const theText = event.currentTarget.textContent;
        // e.currentTarget.classList.remove('btn-primary');
        // e.currentTarget.classList.add('btn-info');
        // console.log(e);
        // var test = $('#card_defult');
        if(e.currentTarget.innerText == 'Card'){
          $('#logo').addClass('d-none');
          $('#card_detail').addClass('d-none');
          $('#elem_barcode').addClass('d-none');
          $('#card_defult').removeClass('d-none');
          $('.btnbarcode').removeClass('active');
          $('#elem_qrcode').addClass('d-none');
          $('.btnqr').removeClass('active');
          e.currentTarget.classList.add('active');
          setactiveCard(true);
          setactiveQr(false)
          setactiveBarcode(false)
        }else if(e.currentTarget.id == 'card_defult'){
          $('#logo').addClass('d-none');
          $('#card_detail').removeClass('d-none');
          $('#card_defult').addClass('d-none');
          $('#elem_barcode').addClass('d-none');
          $('.btnbarcode').removeClass('active');
          $('#elem_qrcode').addClass('d-none');
          $('.btnqr').removeClass('active');

        }else if(e.currentTarget.id == 'card_detail'){
          $('#logo').addClass('d-none');
          $('#card_detail').addClass('d-none');
          $('#card_defult').removeClass('d-none');
          $('#elem_barcode').addClass('d-none');
          $('.btnbarcode').removeClass('active');
          $('.btnqr').removeClass('active');
          $('#elem_qrcode').addClass('d-none');
        }else if(e.currentTarget.innerText == 'Barcode'){
          $('#logo').addClass('d-none');
          $('#card_detail').addClass('d-none');
          $('#card_defult').addClass('d-none');
          $('#elem_barcode').removeClass('d-none');
          $('.btncard').removeClass('active');
          $('#elem_qrcode').addClass('d-none');
          $('.btnqr').removeClass('active');
          e.currentTarget.classList.add('active');
          setactiveCard(false);
          setactiveQr(false)
          setactiveBarcode(true)
        }else if(e.currentTarget.innerText == 'QRCode'){
          $('#logo').addClass('d-none');
          $('#card_detail').addClass('d-none');
          $('#card_defult').addClass('d-none');
          $('#elem_barcode').addClass('d-none');
          $('#elem_qrcode').removeClass('d-none');
          $('.btncard').removeClass('active');
          $('.btnbarcode ').removeClass('active');
          e.currentTarget.classList.add('active');
          setactiveCard(false);
          setactiveQr(true)
          setactiveBarcode(false)
        }
        // console.log(test);
    };


  const [blogs, setBlogs] = useState([])
  const logout = () => {
    liff.logout();
    window.location.reload();
  }
  const [name, setName] = useState("");
  const [userLineID, setUserLineID] = useState("");
  const [pictureUrl, setPictureUrl] = useState("");
  const [userclub, setUserclub] = useState("");







  let customerdataweb = window.sessionStorage.getItem('Customerdata');
  let customerdatawebconvert = "" + customerdataweb;
  const customerdata = JSON.parse(customerdatawebconvert);


  /// style web
  let stylesweb = JSON.parse("" + window.sessionStorage.getItem('stylesetup'));

  const styles = {
        member_detail_box: {
          "backgroundColor": stylesweb.member_detail_box.background_color,
          "border": stylesweb.member_detail_box.border,
          "border-color": stylesweb.member_detail_box.border_color,
          "border-radius":stylesweb.member_detail_box.border_radius,
          "color": stylesweb.member_detail_box.font_color,
          "font-family": stylesweb.member_detail_box.font_name,
          "font-size": stylesweb.member_detail_box.font_size,
          "font-weight": stylesweb.member_detail_box.font_weight,
          "width": "100%",
        },
        member_name: {
          "backgroundColor": stylesweb.member_name.background_color,
          "border": stylesweb.member_name.border,
          "border-color": stylesweb.member_name.border_color,
          "border-radius":stylesweb.member_name.border_radius,
          "color": stylesweb.member_name.font_color,
          "font-family": stylesweb.member_name.font_name,
          "font-size": stylesweb.member_name.font_size,
          "font-weight": stylesweb.member_name.font_weight,
        },
        member_tel_and_point: {
          "backgroundColor": stylesweb.member_tel_and_point.background_color,
          "border": stylesweb.member_tel_and_point.border,
          "border-color": stylesweb.member_tel_and_point.border_color,
          "border-radius":stylesweb.member_tel_and_point.border_radius,
          "color": stylesweb.member_tel_and_point.font_color,
          "font-family": stylesweb.member_tel_and_point.font_name,
          "font-size": stylesweb.member_tel_and_point.font_size,
          "font-weight": stylesweb.member_tel_and_point.font_weight,
        },
        general_button_style_hover_active_style: {
          "backgroundColor": stylesweb.general_button_style_hover_active_style.background_color,
          "border": stylesweb.general_button_style_hover_active_style.border,
          "border-color": stylesweb.general_button_style_hover_active_style.border_color,
          "border-radius":stylesweb.general_button_style_hover_active_style.border_radius,
          "color": stylesweb.general_button_style_hover_active_style.font_color,
          "font-family": stylesweb.general_button_style_hover_active_style.font_name,
          "font-size": stylesweb.general_button_style_hover_active_style.font_size,
          "font-weight": stylesweb.general_button_style_hover_active_style.font_weight,
        },
        general_button_style: {
          "backgroundColor": stylesweb.general_button_style.background_color,
          "border": stylesweb.general_button_style.border,
          "border-color": stylesweb.general_button_style.border_color,
          "border-radius":stylesweb.general_button_style.border_radius,
          "color": stylesweb.general_button_style.font_color,
          "font-family": stylesweb.general_button_style.font_name,
          "font-size": stylesweb.general_button_style.font_size,
          "font-weight": stylesweb.general_button_style.font_weight,
        },
        foreground_Style: {
          "backgroundColor": stylesweb.foreground_Style.background_color,
          "border": stylesweb.foreground_Style.border,
          "border-color": stylesweb.foreground_Style.border_color,
          "border-radius": stylesweb.foreground_Style.border_radius,
          "color": stylesweb.foreground_Style.font_color,
          "font-family": stylesweb.foreground_Style.font_name,
          "font-size": stylesweb.foreground_Style.font_size,
          "font-weight": stylesweb.foreground_Style.font_weight,
        },
        background_Style: {
          "backgroundColor": stylesweb.background_Style.background_color,
          "border": stylesweb.background_Style.border,
          "border-color": stylesweb.background_Style.border_color,
          "border-radius": stylesweb.background_Style.border_radius,
          "color": stylesweb.background_Style.font_color,
          "font-family": stylesweb.background_Style.font_name,
          "font-size": stylesweb.background_Style.font_size,
          "font-weight": stylesweb.background_Style.font_weight,
        }

  };










  // console.log(styles);

  /*  function checkcustomerlogin() {
      const clubid = window.sessionStorage.getItem("Club_Code");

      let clubidweb= ""+clubid;

      if (clubidweb) {
          console.log(userLineID);
        if (userLineID) {
          console.log("sucdd");

        }
      }
    }*/




  return (


    <div className='card card-homepage main-custom-container'>
      {/* begin::Form */}

      <div className='row mb-8 imagelogo' style={styles.background_Style}>
        <img src={logo} alt="metronic" />
      </div>

      {/* < a href={data1} target="__blank"> Download </a> */}
      <div className='card-body-homepage ' >
        <div className='block-homepage showinfo' style={styles.member_detail_box}>
          <label className='card-label   mb-1 col-form-label middle-lable' style={styles.member_name}>{customerdata.first_name + ' ' + customerdata.last_name}</label>

          <div className='block-buttom-homepage'>
            <div className='block-buttom-lable middle text-left'>
              <label className='card-label' style={styles.member_tel_and_point}>{customerdata.mobile_phone_no}</label>
            </div>
            <div className='block-buttom-lable middle text-right'>
              <label className='card-label' style={styles.member_tel_and_point}>{formatNumber("en-US", customerdata.ramianing_point)} Point</label>
            </div>
          </div>
          {/* //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point */}
          <div
            className='block-buttom-homepage'
            style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: "10px"}}
          >
            <div className='text-left' style={{display: 'inline'}}>
              <label className='card-label' style={styles.member_tel_and_point}>
                <span>Point ที่จะหมดอายุ</span> {dateFormat}
              </label>
            </div>
            <div className='text-right' style={{display: 'inline', whiteSpace: "nowrap"}}>
              <label className='card-label' style={styles.member_tel_and_point}>
                {formatNumber("en-US", customerdata.nearlyExpirePoint)} Point
              </label>
            </div>
          </div>
          {/* //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point */}
        </div>
      </div>

      {/* end::Form */}

      {/* begin::Form */}



      <div className='card-body-homepage-middle '>

        <div className='block-homepage showbody custom-body' style={styles.foreground_Style}>
          <div className='block-homepage-body'>
            <div className='block-image-body d-flex justify-content-center'>
              {/* <img src={logoImage} alt="metronic"/> */}

              <Card className="" id="card_defult" onClick={(e) => checkBtnClick(e)} >
                <Card.Img variant="top" src={cardImage} />
              </Card>
              <Card className="text-dark d-none" id="card_detail" onClick={(e) => checkBtnClick(e)}>
                <Card.Img variant="top" src={cardDetailImage} />

              </Card>
              {/* <Card  id="elem_barcode" className="d-none"> */}
              <Card id="elem_barcode" className="d-none w-100 border-1 border-dark">
                <Card.Img variant="top" id="barcode" />
              </Card>
              {/* </Card> */}
              <Card id="elem_qrcode" className="d-none border-1 border-dark">
                <QRCode value={customer_Data.mobile_phone_no} />
              </Card>
            </div>
            <div className='block-homepage-body-button d-flex justify-content-center'>
              <Button type='button' className='btncard btnhomepage w-auto btn-info active' style={(activeCard == true) ? styles.general_button_style_hover_active_style : (activeCard == false && activeBarcode == false && activeQr == false) ? styles.general_button_style_hover_active_style : styles.general_button_style} onClick={(e) => checkBtnClick(e)}>
                Card
              </Button>{' '}
              <Button type='button' className='btnbarcode btnhomepage w-auto btn-info' style={(activeBarcode == true) ? styles.general_button_style_hover_active_style : styles.general_button_style} onClick={(e) => checkBtnClick(e)}>
                Barcode
              </Button>{' '}
              <Button type='button' className='btnqr btnhomepage w-auto btn-info' style={(activeQr == true) ? styles.general_button_style_hover_active_style : styles.general_button_style} onClick={(e) => checkBtnClick(e)}>
                QRCode
              </Button>{' '}

            </div>

          </div>
        </div>
      </div>
      {/* end::Form */}
      {/* //AVCDAAV.002  24/03/2025  Add code for Adding dialog event */}
        <Dialog show={news.length > 0 && news?.[0].news_url !== "" && event.showEvent} handleClose={
            () => {
              window.sessionStorage.setItem("showEvent", "true");
              updateState<EventAlert>({showEvent: false}, setEvent);
            }} 
            // centered width='medium' height='70vh'
            centered width='medium' height='auto'
            closeButtonOuter
            type='image'
          >
            <img src={news[0]?.news_url} alt="news" width={"100%"} height={"auto"} 
              onClick={() => news[0]?.news_link.trimEnd() !== "" ? liff.openWindow({
                url: news[0]?.news_link,
                external: true
              }) : {}}/>
        </Dialog>
      {/* //C-AVCDAAV.002  24/03/2025  Add code for Adding dialog event */}


    </div>


  )
}
